export default __webpack_public_path__ + "static/media/sendlogo-chat.46753cbf.svg";